import dayjs from "dayjs";

// src/Constants/filterOptions.js
export const fillingmodeOptions = [
  { label: "ICEGATE", value: "icegate" },
  { label: "Manual", value: "manual" },
  { label: "Service Center", value: "service" },
  { label: "SEZ", value: "sez" },
];
export const jobOwnerList = [
  { label: "Administrator", value: "Administrator" },
  { label: "Ajitesh Barick", value: "Ajitesh Barick" },
  { label: "Anjan Reddy", value: "Anjan" },
  { label: "Boopathy", value: "Boopathy" },
  { label: "Chandra", value: "Chandra" },
  { label: "Dinesh Singh Rajpur", value: "Dinesh Singh Rajpur" },
  { label: "Export Del", value: "Export Del" },
  { label: "Karthik", value: "Karthik" },
  { label: "Kiran Kumar V", value: "Kiran Kumar V" },
  { label: "Mohan Reddy", value: "Mohan Reddy" },
  { label: "Mythri", value: "Mythri" },
  { label: "Shiva", value: "Shiva" },
  { label: "SUREKHA", value: "SUREKHA" },
  { label: "TAPAN", value: "TAPAN" },
  { label: "Tripathi Mumbai", value: "Tripathi Mumbai" },
  { label: "TRIPATHI MUMBAI 1", value: "TRIPATHI MUMBAI 1" },
  { label: "TRIPATHMAA", value: "TRIPATHMAA" },
  { label: "TRPATH MUMBAI", value: "TRPATH MUMBAI" },
];

export const FllingModeList = [
  { label: "AAGCR9244LPSU00", value: "AAGCR9244LPSU00" },
  { label: "AAHCA3430APSU00", value: "AAHCA3430APSU00" },
  { label: "AAPCS7948KPSU02", value: "AAPCS7948KPSU02" },
  { label: "ARUNKUMBHARE1973", value: "ARUNKUMBHARE1973" },
  { label: "BLRTRIPATH", value: "BLRTRIPATH" },
  { label: "BOMTRIPATH", value: "BOMTRIPATH" },
  { label: "DELTRIPATH", value: "DELTRIPATH" },
  { label: "HPPPSSEZAIR", value: "HPPPSSEZAIR" },
  { label: "HPPPSSEZCHA", value: "HPPPSSEZCHA" },
  { label: "SANDESHGORULE1987", value: "SANDESHGORULE1987" },
  { label: "TRIPATHAMD", value: "TRIPATHAMD" },
  { label: "TRIPATHBLR", value: "TRIPATHBLR" },
  { label: "TRIPATHBLR1", value: "TRIPATHBLR1" },
  { label: "TRIPATHBLR2", value: "TRIPATHBLR2" },
  { label: "TRIPATHCCU123", value: "TRIPATHCCU123" },
  { label: "TRIPATHHYD", value: "TRIPATHHYD" },
  { label: "TRIPATHMAA", value: "TRIPATHMAA" },
];



export const CustomHouse = [ 
{label : "Visakapattinam",value: "Visakapattinam"},
{label : "ICD Hosur",value: "ICD Hosur"},
{label : "Bengaluru ICD",value: "Bengaluru ICD"},
{label : "Primal Project Private Limited",value: "Primal Project Private Limited"},
{label : "Bengaluru Air Cargo",value: "Bengaluru Air Cargo"},
{label : "Chennai Air Cargo",value: "Chennai Air Cargo"},
]

export const ImportBEType = [
  {label :"Home",value : "Home"},
  { label: "InBond", value: "InBond" },
  { label: "ExBond", value: "ExBond" },
  {label : "SEZ-Z | SEZ Bill of entry",value : "SEZ-Z | SEZ Bill of entry"},
  {label : "SEZ-M | DTA Sales manufacturing",value : "SEZ-M | DTA Sales manufacturing"},
  {label : "SEZ-T | DTA Sales Trading",value : "SEZ-T | DTA Sales Trading"},
  {label : "SEZ-V | Movement of goods",value : "SEZ-V | Movement of goods"},
  {label : "SEZ-S | Clearance of goods",value : "SEZ-S | Clearance of goods"},

]

// export const defaultValues = {
//   exportJobDate: dayjs(), // today
//   exportJobReceivedOn: dayjs(), // current date-time
//   exportJOBOwner: jobOwnerList[0]?.value || "",
//   exporterJobFillingMode: fillingmodeOptions[0]?.value || "",
//   exporterJobFillingType: FllingModeList[0]?.value || "",
//   exportTransportMode: "air",
//   exportCustomHouse: "Bengaluru Air Cargo",
//   exportLoadingPort: "688b468a88447da91180231d",
//   exportSBType: ImportBEType[0]?.value || "",
// };  
